var map = {
	"./bg_page.png": "bc59",
	"./heart.png": "f655",
	"./union.png": "3155",
	"./union_2.png": "38fc",
	"./wilki_1.jpg": "4d4e",
	"./wilki_2.jpg": "523e",
	"./wilki_3.jpg": "c6fe",
	"./wolf_bg.jpg": "068f",
	"./wolf_bg_mob.jpg": "dd5a",
	"./wolf_family.jpg": "f9f2",
	"./wolfcard_1.png": "61b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eecd";